import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'
import { fetchParentStudents, getActiveStudentId } from '../../lib/parentStudents'

export default function ParentHomework() {
  const [homework, setHomework] = useState([])
  const [student, setStudent] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchData() {
      const { data: { user } } = await supabase.auth.getUser()

      if (!user) {
        setLoading(false)
        return
      }

      const { students } = await fetchParentStudents(user.id)

      const activeId = getActiveStudentId(students)
      const activeStudent = students.find(s => s.id === activeId)

      if (!activeStudent) {
        setLoading(false)
        return
      }

      setStudent(activeStudent)

      const { data } = await supabase
        .from('homework')
        .select('*')
        .eq('student_id', activeStudent.id)
        .order('date', { ascending: false })

      setHomework(data || [])
      setLoading(false)
    }

    fetchData()

    window.addEventListener('parent-student-changed', fetchData)

    return () => {
      window.removeEventListener('parent-student-changed', fetchData)
    }
  }, [])

  const statusCfg = {
    done: {
      label: 'Submitted',
      cls: 'badge-success'
    },
    late: {
      label: 'Late',
      cls: 'badge-warning'
    },
    missing: {
      label: 'Not submitted',
      cls: 'badge-danger'
    },
  }

  if (loading) {
    return <div className="empty">Loading...</div>
  }

  return (
    <div>
      <h2 style={{
        fontSize: 20,
        fontWeight: 500,
        marginBottom: 20
      }}>
        Homework
      </h2>

      {student && (
        <div style={{
          fontSize: 13,
          color: 'var(--text3)',
          marginBottom: 12
        }}>
          Showing homework for{' '}
          <strong style={{ color: 'var(--text2)' }}>
            {student.name}
          </strong>
        </div>
      )}

      {homework.length === 0 ? (
        <div className="empty">
          No records
        </div>
      ) : (
        <>
          {/* Desktop */}
          <div className="desktop-table">
            <div
              className="card"
              style={{
                padding: 0,
                overflow: 'hidden'
              }}
            >
              <table>
                <thead>
                  <tr>
                    <th>Homework</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Note</th>
                  </tr>
                </thead>

                <tbody>
                  {homework.map(h => (
                    <tr key={h.id}>
                      <td style={{ fontWeight: 500 }}>
                        {h.title}
                      </td>

                      <td style={{ color: 'var(--text3)' }}>
                        {h.date}
                      </td>

                      <td>
                        <span
                          className={`badge ${
                            statusCfg[h.status]?.cls || 'badge-warning'
                          }`}
                        >
                          {statusCfg[h.status]?.label || h.status}
                        </span>
                      </td>

                      <td style={{ color: 'var(--text3)' }}>
                        {h.note || '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile */}
          <div className="mobile-cards">
            {homework.map(h => (
              <div
                key={h.id}
                className="mobile-card"
              >
                <div className="mobile-card-row">
                  <div>
                    <div style={{
                      fontWeight: 600,
                      fontSize: 15
                    }}>
                      {h.title}
                    </div>

                    <div style={{
                      fontSize: 12,
                      color: 'var(--text3)',
                      marginTop: 4
                    }}>
                      {h.date}
                    </div>
                  </div>

                  <span
                    className={`badge ${
                      statusCfg[h.status]?.cls || 'badge-warning'
                    }`}
                  >
                    {statusCfg[h.status]?.label || h.status}
                  </span>
                </div>

                {/* NOTE — this was missing from the mobile version */}
                <div style={{
                  marginTop: 10,
                  paddingTop: 10,
                  borderTop: '1px solid var(--border)'
                }}>
                  <div style={{
                    fontSize: 11,
                    color: 'var(--text3)',
                    marginBottom: 3
                  }}>
                    Note
                  </div>

                  <div style={{
                    fontSize: 13,
                    color: h.note
                      ? 'var(--text2)'
                      : 'var(--text3)',
                    overflowWrap: 'anywhere'
                  }}>
                    {h.note || '—'}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}